
import { defineComponent, PropType } from 'vue'
import tippy from 'tippy.js'

type Trigger = 'mouseenter' | 'click'
type TagName = 'span' | 'div'
type TipPosition =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end'
  | 'auto'
  | 'auto-start'
  | 'auto-end'

export default defineComponent({
  name: 'NrTooltip',
  props: {
    tagName: {
      type: String as PropType<TagName>,
      default: 'span'
    },
    trigger: {
      type: String as PropType<Trigger>,
      default: 'mouseenter'
    },
    position: {
      type: String as PropType<TipPosition>,
      default: 'bottom'
    },
    // This label prop will be rendered as plain text. If you need to render HTML, please use the label slot instead.
    label: {
      type: String,
      default: 'Tooltip content goes here'
    },
    parentTarget: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { tip: undefined }
  },

  mounted() {
    const targetEl = this.parentTarget
      ? this.$el.parentElement
      : this.$refs.trigger

    if (!targetEl) {
      return
    }

    this.tip = tippy(targetEl, {
      // allowHTML should not ever be needed here because we are passing in a DOM element as the content and not a string.
      allowHTML: false,
      arrow: true,
      content: this.$refs.label,
      placement: this.position,
      trigger: this.trigger,
      popperOptions: {
        modifiers: [
          {
            name: 'computeStyles',
            options: {
              gpuAcceleration: false
            }
          }
        ]
      }
    })
  },

  beforeDestroy() {
    this.tip?.destroy()
    this.tip = undefined
  }
})
